export const getColumnSize = (count: number) => {
  if (count <= 0) {
    return { xs: 12, lg: 12 };
  }
  const xs = Math.max(4, Math.floor(12 / count));
  const lg = Math.max(3, Math.floor(12 / count));
  return { xs, lg };
};

export const extractNumericValue = (str: string): number | null => {
  const numericMatch = str.match(/[-+]?\d*\.?\d+/g);

  if (numericMatch && numericMatch[0]) {
    const numFromName = parseFloat(numericMatch[0]);

    if (!isNaN(numFromName)) {
      return numFromName;
    }
  }

  return null;
};
